import React, { Component } from "react";

// import Lottie from "lottie-web";

// import LoopingAnimation from "../../assets/lottie_animations/loading-looper.json";

import ReactLoading from 'react-loading';

export default class AnimatedLoader extends Component {
  componentDidMount() {
    // if (Lottie) {
    //   this.animation = Lottie.loadAnimation({
    //     container: this.SpinnerRef.current, 
    //     renderer: "svg",
    //     loop: true,
    //     autoplay: true,
    //     animationData: LoopingAnimation
    //   });

    //   this.animation.addEventListener("complete", () => {
    //     this.animation.destroy();
    //   });
    // }
  }

  // constructor() {
  //   super();
  //   this.SpinnerRef = React.createRef();
  // }

  render() {
    // return <div className="vmo-animated-loader" ref={this.SpinnerRef} />;
    return <ReactLoading className="vmo-animated-loader react-loader" type="spinningBubbles" color="#FF0000"/>
  }
}
